var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIraq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24_2079)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_2079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_2079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V9.6689H35.2819V3Z",
    fill: "#BD2034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 9.6622H1V16.3311H35.2819V9.6622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 16.3311H1V23H35.2819V16.3311Z",
    fill: "#070707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1004 11.7713C21.0603 11.7513 21.0134 11.7178 21 11.6977C20.9799 11.6642 20.9933 11.6642 21.087 11.691C21.2544 11.7379 21.3683 11.7178 21.4754 11.624L21.5691 11.5437L21.683 11.604C21.7432 11.6374 21.8102 11.6575 21.8303 11.6508C21.8771 11.6374 21.9776 11.5102 21.9776 11.4633C21.9776 11.4098 22.0177 11.4232 22.0445 11.4834C22.0914 11.604 22.0244 11.7379 21.9106 11.7713C21.8503 11.7847 21.8035 11.778 21.7164 11.7513C21.6093 11.7178 21.5959 11.7178 21.5423 11.758C21.4084 11.8383 21.2477 11.845 21.1004 11.7713Z",
    fill: "#439B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5156 11.383C21.4754 11.3294 21.4285 11.1353 21.4419 11.0817C21.4553 11.0415 21.4687 11.0281 21.5089 11.0415C21.5758 11.0616 21.5892 11.1085 21.5825 11.2625C21.5758 11.4031 21.5557 11.4366 21.5156 11.383Z",
    fill: "#439B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5875 11.2424C16.5742 11.3361 16.7549 11.5772 16.842 11.6173C16.7884 11.6441 16.7148 11.6307 16.6612 11.6575C16.3733 11.9454 15.3221 12.9699 15.1279 13.2176C15.697 13.231 16.3264 13.2109 16.8621 13.1841C16.8621 12.7958 17.2303 12.7757 17.4714 12.6351C17.5986 12.836 17.9133 12.8159 17.9535 13.1172C17.9535 13.472 17.9535 14.0144 17.9535 14.4027H13.0924C13.0054 14.7777 12.6639 15.0656 12.1885 14.9518C12.3358 14.7978 12.5835 14.7442 12.6706 14.53C12.7442 14.068 12.5233 13.78 12.376 13.5122C12.617 13.4252 12.6505 13.4051 12.8982 13.2377C12.7308 13.76 13.3401 13.6997 13.8021 13.6863C13.8155 13.5122 13.8088 13.3047 13.6749 13.2779C13.849 13.2176 13.8825 13.1908 14.157 12.9565V13.6595C15.2417 13.6595 16.4135 13.6528 17.5249 13.6528C17.5249 13.4319 17.5852 13.0837 17.4111 13.0837C17.2437 13.0837 17.4044 13.5323 17.2772 13.5323H14.6793C14.6793 13.4386 14.6793 13.231 14.6793 13.0904C14.7864 12.9833 14.7797 12.99 15.5296 12.2333C15.5966 12.1731 16.1255 11.691 16.5875 11.2424Z",
    fill: "#439B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0891 11.229C23.2698 11.3294 23.4171 11.4633 23.6381 11.5169C23.6113 11.6106 23.531 11.6441 23.5109 11.7446V13.7064C23.7586 13.76 23.8122 13.6193 23.9327 13.5457C23.9662 13.8604 24.1671 14.1684 24.1604 14.4161H23.0958V11.229H23.0891Z",
    fill: "#439B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6696 12.2802C21.6696 12.2802 22.0579 11.9521 22.0579 11.9387V13.6528H22.3391C22.3391 12.9967 22.3324 12.3338 22.3324 11.7312C22.4463 11.6173 22.6672 11.4566 22.7208 11.3428V14.4094C21.9374 14.4094 20.471 14.4094 20.2769 14.4094C20.2434 13.7734 20.2367 13.1105 20.9799 13.2511V12.9967C20.9598 12.9498 20.9196 13.01 20.9063 12.9498C21.0268 12.8293 21.067 12.8025 21.3816 12.5213C21.3816 12.856 21.3883 13.6528 21.3883 13.6528C21.4687 13.6528 21.616 13.6528 21.6696 13.6528C21.6696 13.6528 21.6696 12.3204 21.6696 12.2802ZM20.759 13.6327C20.8125 13.7131 20.9866 13.7131 20.9799 13.5792C20.9464 13.472 20.7121 13.5122 20.759 13.6327Z",
    fill: "#439B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6883 14.6237C13.7687 14.6237 13.8356 14.6907 13.8356 14.771C13.8356 14.8514 13.7687 14.9183 13.6883 14.9183C13.608 14.9183 13.541 14.8514 13.541 14.771C13.541 14.6907 13.608 14.6237 13.6883 14.6237Z",
    fill: "#439B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2882 11.229C18.469 11.3294 18.6163 11.4633 18.8373 11.5169C18.8105 11.6106 18.7302 11.6441 18.7101 11.7446V13.7064C18.9578 13.76 19.0114 13.6193 19.1319 13.5457C19.1654 13.8604 19.3662 14.1684 19.3596 14.4161H18.2949V11.229H18.2882Z",
    fill: "#439B4B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24_2079",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24_2079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24_2079",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIraq);
export default __webpack_public_path__ + "static/media/Iraq.1cbd186c5615f0eda18852515c727052.svg";
export { ForwardRef as ReactComponent };